var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"head"},[_c('Head')],1),_c('img',{attrs:{"src":require("@/image/biaozhunhua/biaozhunhua.jpg"),"alt":""}}),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }